export const PLUGIN_KEY = "plugin-nodemailer";
export const LUCID_VERSION = "0.x.x";
